import { authedRequest } from './requests';

/**
 *
 * /leads resource requests
 *
 */
export const getLeads = (token, params) => authedRequest(`v2/leads${params}`, token).then(r => r);

export const downloadLeads = (token, params) => {
  return authedRequest(`v2/download-leads${params}`, token).then(r => r);
}
